var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLargeGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 235,
    viewBox: "0 0 132 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.508 69.5326C163.04 69.5326 192.332 74.0571 214.419 81.6607C241.03 90.8222 257.391 104.709 257.391 117.283C257.391 130.386 240.051 145.139 211.475 154.607C189.87 161.765 161.44 165.501 131.508 165.501C100.819 165.501 71.7592 161.994 49.9111 154.528C22.2693 145.08 5.62038 130.137 5.62038 117.283C5.62038 104.811 21.2422 91.0314 47.4791 81.884C69.6479 74.155 99.6636 69.5326 131.504 69.5326H131.508Z",
    stroke: "#33373E",
    strokeWidth: 11.2354
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9433 93.5446C105.696 66.2295 124.249 43.1146 141.869 27.7803C163.1 9.30464 183.303 2.06907 194.195 8.3501C205.547 14.8961 209.664 37.2877 203.589 66.7721C199.002 89.064 188.031 115.558 173.078 141.487C157.746 168.072 140.191 191.494 122.81 206.686C100.817 225.912 79.5543 232.869 68.4196 226.448C57.615 220.221 53.4832 199.801 58.6664 172.502C63.0459 149.437 74.0364 121.126 89.9382 93.5441L89.9433 93.5446Z",
    stroke: "#33373E",
    strokeWidth: 11.2354
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9729 141.557C74.1755 114.272 63.42 86.6498 58.9305 63.7259C53.5263 36.1057 57.3472 14.9879 68.2296 8.68857C79.5698 2.12338 101.025 9.73908 123.536 29.7268C140.555 44.8383 158.032 67.5698 173.029 93.4748C188.404 120.034 199.928 146.941 204.411 169.586C210.084 198.242 205.492 220.138 194.368 226.577C183.574 232.826 163.822 226.21 142.76 208.086C124.965 192.773 105.926 169.112 89.9729 141.556V141.557Z",
    stroke: "#33373E",
    strokeWidth: 11.2354
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeGroup);
export default __webpack_public_path__ + "static/media/large_group.fc19f76a0405a3fb5571693dbb20f444.svg";
export { ForwardRef as ReactComponent };